/**
 * @deprecated create your own or use `@panwds/utils`.
 */
export function noop() { }
//# sourceMappingURL=noop.js.map